import React from 'react';

import './styles.scss';

interface OwnProps {
    children: React.ReactElement | string | number;
}

type Props = OwnProps;

export default class TableCellTag extends React.PureComponent<Props> {
    render(): React.ReactElement {
        const { children } = this.props;

        return <span className="table-cell-tag">{children}</span>;
    }
}
